module.exports = __webpack_public_path__ + "static/media/tensorflowLogo.82080889.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Technologies/Assets/tensorflowLogo.svg
// module id = 520
// module chunks = 1